var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecreationArea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6327",
    "data-name": "Rectangle 6327",
    width: 40,
    height: 39.082,
    fill: "#c8d1ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34923",
    "data-name": "Group 34923",
    transform: "translate(-5131 -5527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6340",
    "data-name": "Rectangle 6340",
    width: 74,
    height: 74,
    rx: 12,
    transform: "translate(5131 5527)",
    fill: "#f1f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34896",
    "data-name": "Group 34896",
    transform: "translate(5148 5544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34876",
    "data-name": "Group 34876",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24391",
    "data-name": "Path 24391",
    d: "M40,43.233c-.181-.011-.362-.033-.542-.033H.005V40.868H2.379V38.441H0V36.114H7.072v2.3H4.778v2.411H9.416V33.745H4.774V31.414H16.447v2.315H11.8v7.1h4.648V38.435H14.145V36.111h6.987v2.31H18.844v2.4h6.993V33.775h7.037v7.079h.486q3.088,0,6.175,0c.155,0,.31.022.464.033Z",
    transform: "translate(0 -4.152)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24392",
    "data-name": "Path 24392",
    d: "M27.357,13.164h-1.7L32.239,0l6.586,13.17h-1.7l4.209,7.019H38.905l3.948,7.029H21.713c1.283-2.336,2.543-4.628,3.837-6.985H23.123l4.233-7.068",
    transform: "translate(-2.869 0)",
    fill: "#c8d1ec"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecreationArea);
export default __webpack_public_path__ + "static/media/recreationArea.98b9b74acb7672bc26a54518f8036e40.svg";
export { ForwardRef as ReactComponent };